module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("footer_termsofservice_links", [["a",{"href":"/privacy-policy"},[["textNode",{"text":"Privacy Policy"}]]],["textNode",{"text":" "}],["a",{"href":"/operator-agreement"},[["textNode",{"text":"Operator Agreement"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!../common/templates/layout/footerLinks.tpl
// module id = 409
// module chunks = 2